module.exports = __webpack_public_path__ + "img/alteralyticsBlack.1e683fb9.gif";